var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 26C23.3333 24.1392 23.3333 23.2089 23.1037 22.4518C22.5866 20.7473 21.2527 19.4134 19.5482 18.8963C18.7911 18.6667 17.8608 18.6667 16 18.6667H9.33334C7.47258 18.6667 6.54221 18.6667 5.78514 18.8963C4.08061 19.4134 2.74672 20.7473 2.22965 22.4518C2 23.2089 2 24.1392 2 26M18.6667 8C18.6667 11.3137 15.9804 14 12.6667 14C9.35296 14 6.66667 11.3137 6.66667 8C6.66667 4.68629 9.35296 2 12.6667 2C15.9804 2 18.6667 4.68629 18.6667 8Z",
    stroke: "#38CB89",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGreen);
export default __webpack_public_path__ + "static/media/users-green.9568b267bc838c908f75829d8e412514.svg";
export { ForwardRef as ReactComponent };